import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, IconButton, Link, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import "../../App.css";
import SendWatchlistIcon from "../../assets/USA_Images/WatchlistIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import WatchlistViewProfile from "../../components/VisitorActionsComponents/WatchlistViewProfile";
import { getAllWatchlistTemplate } from "../../slices/WatchlistGlobal/WatchlistGlobalSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import EditIcon from "../Person/EditIcon";
import DeleteIcon from "./DeleteIcon";
import DeleteWatchlist from "./DeleteWatchlist";
import WatchlistFilterForm from "./WatchlistFilterForm";
import WatchlistInfo from "./WatchlistInfo";
import WatchlistTemplateForm from "./WatchlistTemplateForm";

export default function WatchlistTemplate(props) {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [open, setOpen] = useState(false);
  const [clear, setClear] = React.useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteVisitor, setOpenDeleteVisitor] = useState(false);
  const [watchlistId, setWatchlistId] = useState();
  const [watchlistContactEmail, setWatchlistContactEmail] = useState();
  const [country, setCountry] = useState("");
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [openInformation, setOpenInformation] = React.useState(false);
  const zlink = localStorage.getItem("redirectFrom");

  const [selectedObject, setSelectedObject] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneCountryCode: "",
    phoneNumber: "",
    contactEmail: "",
    contactPhoneCountryCode: "",
    contactPhoneNumber: "",
    visitorCompanyName: "",
    purposeTypeId: "",
  });

  const [filter, setFilter] = React.useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneCountryCode: "",
    phoneNumber: "",
    contactEmail: "",
    contactPhoneCountryCode: "",
    contactPhoneNumber: "",
    visitorCompanyName: "",
    purposeTypeId: "",
    isPagable: true,
  });

  const defaultFilter = {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneCountryCode: "",
    phoneNumber: "",
    contactEmail: "",
    contactPhoneCountryCode: "",
    contactPhoneNumber: "",
    visitorCompanyName: "",
    purposeTypeId: "",
    isPagable: true,
  };

  const applyFilter = (filterData) => {
    setClear(true);
    const query = {
      firstName: filterData.firstName,
      lastName: filterData.lastName,
      email: filterData.email,
      phoneCountryCode: filterData.phoneCountryCode,
      phoneNumber: filterData.phoneNumber,
      visitorCompanyName: filterData.visitorCompanyName,
      contactEmail: filterData.contactEmail,
      contactPhoneCountryCode: filterData.contactPhoneCountryCode,
      contactPhoneNumber: filterData.contactPhoneNumber,
      purposeTypeId: filterData.purposeTypeId,
    };

    setFilter({
      ...filter,
      ...query,
    });
  };

  const resetFilter = () => {
    setClear(false);
    setFilter({
      ...defaultFilter,
    });
  };

  const handleChange = (newPage, size) => {
    setPage(newPage - 1);
    loadData(newPage == 0 ? 0 : newPage - 1, size);
    setRowsPerPage(size);
  };

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    loadData(0, rowsPerPage);
  }, [filter]);

  const loadData = (page, rowsPerPage) => {
    const payload = {
      filter: filter,
      page: page,
      rowsPerPage: rowsPerPage,
    };

    dispatch(getAllWatchlistTemplate(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI1000" && data.data) {
          setTotalRecords(data.data.totalCount);
          setRows(data.data.watchLists);
          setPage(data.data.currentPage + 1);
          setTotalPages(data.data.totalPages);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleEditVisit = (params) => {
    setOpenEditDialog(!openEditDialog);
    setSelectedObject(params);
    setDiaLogBoxBlur(true);
  };

  const handleDeleteVisit = (params) => {
    setOpenDeleteVisitor(!openDeleteVisitor);
    setWatchlistId(params.id);
    setWatchlistContactEmail(params.row.contactEmail);
    setDiaLogBoxBlur(true);
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },

    {
      field: "name",
      headerName: t("COMMON014"),
      flex: 1,
      width: 110,
      valueGetter: (params) => params.row.firstName + " " + params.row.lastName,
    },

    {
      field: "email",
      headerName: t("COMMON042"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.email,
    },

    {
      field: "phoneNumber",
      headerName: t("COMMON063"),
      type: "singleSelect",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        params.row.phoneNumber
          ? params.row.phoneCountryCode + "" + -params.row.phoneNumber
          : "",
    },

    {
      field: "contactEmail",
      headerName: t("WATCHLISTTEMP002"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.contactEmail,
    },

    {
      field: "contactPhoneNumber",
      headerName: t("WATCHLISTTEMP009"),
      type: "singleSelect",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        params.row.contactPhoneNumber
          ? params.row.contactPhoneCountryCode +
          "" +
          -params.row.contactPhoneNumber
          : "",
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 205,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <WatchlistViewProfile
          title="Watchlist Details"
          rowData={params.row} />,
        <Box onClick={() => handleEditVisit(params.row)}>
          <EditIcon />
        </Box>,
        <Box onClick={() => handleDeleteVisit(params)}>
          <DeleteIcon />
        </Box>,
      ],
    },
  ]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      {!zlink ? (
        <>
          <HeaderToolbar
            title={t("WATCHLISTTEMP001")}
            tooltipTitle={t("WATCHLIST005")}
          />
        </>
      ) : (
        <>
          <HeaderToolbar
            title={t("WATCHLISTTEMP001")}
            tooltipTitle={t("WATCHLIST005")}
          />

          <Box style={{ marginLeft: "145px", marginTop: "-55px" }}>
            <IconButton onClick={() => setOpenInformation(!openInformation)}>
              <WatchlistInfo />
            </IconButton>
          </Box>
        </>
      )}

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {"Clear Filter"}
            </Link>
          )}
        </Box>
        {!zlink ? (
          <Tooltip title={t("WATCHLISTTEMP001")}>
            <Box
              item
              className={"addIcon"}
              onClick={handleOpen}
              style={{ marginLeft: "5px" }}
            >
              <CreateIcon />
            </Box>
          </Tooltip>
        ) : (
          <Box
            style={{
              textAlign: "center",
              padding: "10px",
              backgroundColor: process.env.REACT_APP_BG_ICON,
              borderRadius: "50%",
              cursor: "pointer",
              // width:'45px', height:'45px'
              marginRight: "10px",
            }}
          >
            <Tooltip
              title={!zlink ? t("WATCHLISTTEMP001") : t("WATCHLISTTEMP001")}
            >
              <img
                alt="..."
                src={!zlink ? SendWatchlistIcon : SendWatchlistIcon}
                onClick={handleOpen}
                style={{ width: "22px" }}
              />
            </Tooltip>
          </Box>
        )}

        <Tooltip title={t("COMMON002")}>
          <Box item
            className="refreshIcon"
          >
            <RefreshIcon onClick={() => loadData(page, rowsPerPage)} />
          </Box>
        </Tooltip>

        <Box item>
          <WatchlistFilterForm
            rowsPerPage={rowsPerPage}
            country={country}
            applyFilter={(data) => applyFilter(data)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", paddingTop: "10px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {open && (
        <WatchlistTemplateForm
          selectedObject={selectedObject}
          open={open}
          country={country}
          handleClose={() => {
            handleClose(loadData(0, rowsPerPage));
            setDiaLogBoxBlur(false);
          }}
        />
      )}

      {openEditDialog && (
        <WatchlistTemplateForm
          selectedObject={selectedObject}
          open={openEditDialog}
          country={country}
          handleClose={() => {
            setOpenEditDialog(false);
            loadData(0, rowsPerPage);
            setDiaLogBoxBlur(false);
            setSelectedObject({
              id: "",
              firstName: "",
              lastName: "",
              email: "",
              phoneCountryCode: "",
              phoneNumber: "",
              contactEmail: "",
              contactPhoneCountryCode: "",
              contactPhoneNumber: "",
              visitorCompanyName: "",
              purposeTypeId: "",
            });
          }}
        />
      )}

      {openDeleteVisitor && (
        <DeleteWatchlist
          open={openDeleteVisitor}
          handleClose={(data) => {
            setOpenDeleteVisitor(data);
            loadData(0, rowsPerPage);
            setDiaLogBoxBlur(false);
          }}
          DeleteId={watchlistId}
          watchlistContactEmail={watchlistContactEmail}
        />
      )}
    </>
  );
}
